declare global {
    interface Window {
        grecaptchaSiteKey?: string;
    }
}

const CAPTCHA_LOAD_TIMEOUT = 3000;
const CAPTCHA_POLL_INTERVAL = 100;

const waitForCaptchaScript = async (): Promise<void> => {
    for (let waited = 0; ; waited += CAPTCHA_POLL_INTERVAL) {
        if (typeof grecaptcha !== 'undefined' && grecaptcha.execute) {
            return;
        }

        if (waited >= CAPTCHA_LOAD_TIMEOUT) {
            throw new Error('reCAPTCHA script failed to load');
        }

        await new Promise((resolve) => setTimeout(resolve, CAPTCHA_POLL_INTERVAL));
    }
};

export const getCaptchaToken = async (): Promise<string> => {
    const siteKey = window.grecaptchaSiteKey;
    if (!siteKey) {
        return '';
    }

    await waitForCaptchaScript();
    await new Promise<void>((resolve) => grecaptcha.ready(resolve));

    return grecaptcha.execute(siteKey, { action: 'submit' });
};
